import { combineReducers } from "@reduxjs/toolkit";
import auth, { clearState as clearAuthSlice } from "./authSlice";
import config from "./config";
import { AppDispatch } from "../store";
import { useLocalStorage } from "@/util/Storage";
import game from "./game";
import initialization from "./initialization";
import manageUser from "./manageUser";

const reducer = combineReducers({
	auth,
	config,
	game,
	initialization,
	manageUser,
});

export const clearAllState = () => (dispatch: AppDispatch) => {
	const token = useLocalStorage.get("token");
	if (!token) {
		dispatch(clearAuthSlice());
	}
};

export default reducer;
